import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type CardAppearance_AdHocAssetsShare_Fragment = { __typename?: 'AdHocAssetsShare', appearance: { __typename?: 'AssetAggregateAppearance', cardAspectRatio: Types.AssetAggregateCardAspectRatioEnum, cardFitImage: boolean, cardInfo: boolean, cardLineCount?: number | null, cardSize: Types.AssetAggregateCardSizeEnum } };

export type CardAppearance_Collection_Fragment = { __typename?: 'Collection', appearance: { __typename?: 'AssetAggregateAppearance', cardAspectRatio: Types.AssetAggregateCardAspectRatioEnum, cardFitImage: boolean, cardInfo: boolean, cardLineCount?: number | null, cardSize: Types.AssetAggregateCardSizeEnum } };

export type CardAppearance_CollectionShare_Fragment = { __typename?: 'CollectionShare', appearance: { __typename?: 'AssetAggregateAppearance', cardAspectRatio: Types.AssetAggregateCardAspectRatioEnum, cardFitImage: boolean, cardInfo: boolean, cardLineCount?: number | null, cardSize: Types.AssetAggregateCardSizeEnum } };

export type CardAppearanceFragment = CardAppearance_AdHocAssetsShare_Fragment | CardAppearance_Collection_Fragment | CardAppearance_CollectionShare_Fragment;

export const CardAppearance = /*#__PURE__*/ gql`
    fragment CardAppearance on AssetAggregate {
  appearance {
    cardAspectRatio
    cardFitImage
    cardInfo
    cardLineCount
    cardSize
  }
}
    ` as unknown as DocumentNode<CardAppearanceFragment, unknown>;

        

        
export const useCardAppearanceFragment = (
  input: string | Omit<UseFragmentOptions<CardAppearanceFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'AssetAggregate' } };
    return input;
  })();

  return useFragment<CardAppearanceFragment>({
    fragment: CardAppearance,
    fragmentName: 'CardAppearance',
    ...options,
  });
};
  
        